import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { forkJoin } from 'rxjs';
import { OrganizationService } from './core/organization/organization.service';
import { UserSettingsService } from './core/user/user-data/user-settings/user-settings.service';
import { NotificationsService } from './layout/common/notifications/notifications.service';
import { NotificationsChannel } from './layout/common/notifications/notifications.types';

export const initialDataResolver = () => {
    const navigationService = inject(NavigationService);
    const organizationService = inject(OrganizationService);
    const userSettingsService = inject(UserSettingsService);
    const notificationsService = inject(NotificationsService);

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([
        navigationService.get(),
        userSettingsService.get(),
        organizationService.get(),
        notificationsService.getAll([NotificationsChannel.WEB]),
    ]);
};
